export const resetUserInfo = "reset User info";

export const updateUserInfo = "Update User info";

export const updateStundentInfo = "Update Student info";

export const launchMiniapp = "launch Miniapp barcode";
export const closeBarCodeView = "close BarCode View";
